module.exports = __webpack_public_path__ + "img/16m003-08.d672c555.jpg";